// extracted by mini-css-extract-plugin
export default {"mainContainer":"BottomPart_mainContainer__S34wT","leftCol":"BottomPart_leftCol__C-pxh","title":"BottomPart_title__yQEwP"};